import React, { Component } from "react";

class Intro extends Component {
  render() {
    return (
      <div>
        <div
          id="intro"
          style={{
            zIndex: "10",
            position: "fixed",
            width: "100%",
            height: "100%",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={function (e) {
            if (e.target !== e.currentTarget) return;
            e.currentTarget.style.display = "none";
          }}
        >
          <div
            id="container"
            style={{
              display: "flex",
              flexDirection: "column",
              position: "fixed",
              width: "auto",
              height: "auto",
              maxWidth: "60%",
              maxHeight: "80%",
              backgroundColor: "#FFF",
              padding: "0px 30px",
              borderRadius: "5px",
              border: "2px solid #555",
              boxShadow:
                "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
              overflowY: "scroll",
            }}
            onClick={function (e) {
              console.log("container clicked");
            }}
          >
            <h2 style={{}}>Welcome to LooneyTunes!</h2>
            <h4 style={{ marginTop: "0px" }}>
              Powered by Google with leading tech in Machine Learning and A.I. to see who's at
              risk of forest fires!
            </h4>
            <span style={{ wordWrap: "break-word", marginBottom: "8px" }}>
              Feel free to tap, drag, zoom and explore!
            </span>
            <div style={{ wordWrap: "break-word", marginBottom: "16px" }}>
              <i></i>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src='/Images/logo.png'
                alt="instruction gif"
                style={{
                  width: "45%",
                  marginBottom: "6px",
                  borderRadius: "5px",
                }}
              />
            </div>
            <div style={{textAlign:'center', marginBottom: "6px",}}><b>Color Code - chance of Wildfires</b></div>
            <div style={{ textAlign: "center" }}>
                <span style={{backgroundColor: '#fff', margin: '0px 0px', padding: "0px 8px", borderRadius: "5px", border: "2px solid #555",}}>0-24%</span>
                <span style={{backgroundColor: '#e3ff05', margin: '0px 0px', padding: "0px 8px", borderRadius: "5px", border: "2px solid #555",}}>25-49%</span>
                <span style={{backgroundColor: '#ffa905', margin: '0px 0px', padding: "0px 8px", borderRadius: "5px", border: "2px solid #555",}}>50-74%</span>
                <span style={{backgroundColor: '#f01043', margin: '0px 0px', padding: "0px 8px", borderRadius: "5px", border: "2px solid #555",}}>75-99%</span>
                <span style={{backgroundColor: '#500', margin: '0px 0px', padding: "0px 8px", borderRadius: "5px", border: "2px solid #555",}}>100%</span>
            </div>

            <img
              src="Icons/close.png"
              alt="Close Popup"
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                width: "25px",
                height: "25px",
                cursor: "pointer",
              }}
              onClick={(event) => {
                document.getElementById("intro").style.display = "none";
              }}
            ></img>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;
